//State
export default function(state=null,action){
  switch (action.type) {
    case "COMPLETED_JOBS":
        return action.payload;
    default: return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducer/get_completed_jobs.js